import { Box } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import InputComponent from 'UiKit/input';
import SubmitFormButton from 'UiKit/button/submitFormButton';
import { Condition } from 'Component/others';
import { TextRegular } from 'UiKit/typography';
import usePostLogin from 'Domain/login/usePostLogin';
import { EyeCloseIcon, EyeOpenIcon } from 'Asset/icon';

import { useLoginState } from 'View/login/state';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

const Form = () => {
  const { state, updateState } = useLoginState();
  const { register, handleSubmit, formState, watch } = useForm();
  const { t } = useTranslation('login');

  const { mutate: onLogin, isPending } = usePostLogin();

  const onSubmit = (data) => {
    if (isPending) return;

    onLogin(data);
  };
  const isFormValid = watch('email') && watch('password');

  return (
    <Box className={styles['form__container']} id="login-form">
      <form onSubmit={handleSubmit(onSubmit)} data-testid="form-submit-login">
        <InputComponent
          value={watch('email')}
          margin="0 0 24px 0"
          error={formState?.errors?.email}
          label="Email"
          placeholder="hello@paracorpgroup.com"
          isRequired={true}
          register={{
            ...register('email', {
              required: 'Email required!',
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: 'Entered value does not match email format',
              },
            }),
          }}
        />

        <InputComponent
          placeholder="Masukkan kata sandi"
          margin="0 0 8px 0"
          error={formState?.errors?.password}
          value={watch('password')}
          type={state?.isOpenEye ? 'text' : 'password'}
          label="Password"
          isRequired={true}
          rightButton={
            <Box data-testid="open-password-login-form" className={styles['eye__icon']} onClick={() => updateState({ isOpenEye: !state?.isOpenEye })}>
              <Condition statement={state?.isOpenEye} fallback={<EyeCloseIcon />}>
                <EyeOpenIcon size="18" />
              </Condition>
            </Box>
          }
          register={{
            ...register('password', {
              required: 'Password required!',
            }),
          }}
        />

        <TextRegular className={styles['forget-password__text']}>
          <Link to="/forgot-password">{t('loginPage.forgotPassword')}</Link>
        </TextRegular>

        <SubmitFormButton text="Login" height="42px" width="100%" isLoading={isPending} isValid={isFormValid} data-testid={'submit__login-button'} />
      </form>
    </Box>
  );
};

export default Form;
